import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE_URL } from "@/data/content";
import { IMAGES } from "@/data/images";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description, jsonLd }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", IMAGES.og);
    setMeta("property", "og:url", `${SITE_URL}${pathname}`);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${SITE_URL}${pathname === "/" ? "/" : pathname}`);

    const scripts = [];
    const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
    blocks.forEach((block) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.text = JSON.stringify(block);
      document.head.appendChild(s);
      scripts.push(s);
    });
    return () => scripts.forEach((s) => s.remove());
  }, [title, description, jsonLd, pathname]);

  return null;
};

export const ORG_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Beveilig Alles B.V.",
  url: "https://www.beveiligalles.nl",
  email: "info@beveiligalles.nl",
  telephone: "+31851307675",
  areaServed: "NL",
  brand: { "@type": "Brand", name: "Brandpreventie Recycling" },
};

export const SERVICE_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Thermische branddetectie voor recyclingbedrijven",
  serviceType: "Vroegtijdige thermische branddetectie met Hikvision thermische camera's",
  provider: { "@type": "Organization", name: "Beveilig Alles B.V." },
  areaServed: "Nederland",
  url: SITE_URL,
};

export const breadcrumbJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`,
  })),
});

export const faqJsonLd = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});
